import styled from 'styled-components';

export const EmptyBudgetField = styled.div`
    margin-left: 21px;
`;
